export const skillsData = [
  "Next JS",
  "Node JS",
  "JS",
  "Typescript",
  "Express",
  "Firebase",
  "Kafka",
  "Redis",
  "Bootstrap",
  "Docker",
  "HTML",
  "ViteJS",
  "Javascript",
  "CSS",
  "React",
  "Django",
  "MongoDB",
  "MySQL",
  "Git",
  "Bootstrap",
  "Data Structure",
  "c++",
  "c",
  "Python",
  "canva",
  "Ubuntu",
];

// we can Choose our skills from below.

// AVAILABLE SKILLS

/* 
    HTML
    CSS
    JS 
    React
    Next JS
    Nuxt JS
    Node JS
    Vue
    Angular
    Docker
    Photoshop
    Illustrator
    Svelte
    GCP
    Azure
    Fastify
    Haxe
    Ionic
    Markdown
    Microsoft Office
    Picsart
    Sketch
    Unity
    WolframAlpha
    Adobe XD
    After Effects
    Bootstrap
    Bulma
    CapacitorJs
    Coffeescript
    MemSQL
    C
    C++
    C#
    Python
    Java
    Julia
    Matlab
    Swift
    Ruby
    Kotlin
    Go
    PHP
    Flutter
    Dart
    Typescript
    Swift
    Git
    Figma
    Canva
    Ubuntu
    Bootstrap
    MongoDB
    Tailwind
    ViteJS
    VuetifyJS
    MySQL
    PostgreSQL
    AWS
    Firebase
    Blender
    Premiere Pro
    Adobe Audition
    Deno
    Django
    Gimp
    Graphql
    Lightroom
    MaterialUI
    Nginx
    Numpy
    OpenCV
    Pytorch
    Selenium
    Strapi
    Tensorflow
    Webex
    Wordpress
*/
